import React, { useEffect, useState } from "react";
import axios from "axios";

function HMOPatientsTable({ data }) {
  const [hmoProviders, setHmoProviders] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHmoProviders();
  }, []);

  const fetchHmoProviders = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const financeToken = sessionStorage.getItem("financeToken") || token;

      const financeConfig = {
        headers: {
          Authorization: `Bearer ${financeToken}`,
          "Content-Type": "application/json",
        },
      };

      // Fetch HMO providers list from backend
      const backendBase = process.env.REACT_APP_BACKEND_URL_FINANCE;
      const listRes = await axios.get(
        `${backendBase}/hmo/list/1/1000`,
        financeConfig,
      );

      // Build a map of HMO providers by ID matching hmoProviderId to hmo.id
      const hmoList = listRes?.data?.resultList || [];
      const providersMap = {};

      hmoList.forEach((hmo) => {
        providersMap[hmo.id] = hmo.vendorName || "Unknown Provider";
      });

      setHmoProviders(providersMap);
    } catch (error) {
      console.error("Error fetching HMO providers:", error);
      setHmoProviders({});
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-GB");
  };

  const isValidMembership = (validityDate) => {
    if (!validityDate) return false;
    const membershipDate = new Date(validityDate);
    const today = new Date();
    return membershipDate >= today;
  };

  const getStatusClass = (validityDate) => {
    return isValidMembership(validityDate) ? "text-success" : "text-danger";
  };

  const getStatusText = (validityDate) => {
    return isValidMembership(validityDate) ? "Active" : "Expired";
  };

  if (loading) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "20px",
          fontSize: "clamp(0.85rem, 3vw, 1rem)",
        }}
      >
        Loading HMO data...
      </div>
    );
  }

  return (
    <div
      className="w-100 none-flex-item m-t-40"
      style={{
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
        maxWidth: "100%",
      }}
    >
      <table
        className="bordered-table"
        style={{ minWidth: "600px", width: "100%" }}
      >
        <thead className="border-top-none">
          <tr className="border-top-none">
            <th
              style={{
                whiteSpace: "nowrap",
                padding: "8px 12px",
                fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
              }}
            >
              #
            </th>
            <th
              style={{
                whiteSpace: "nowrap",
                padding: "8px 12px",
                fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
              }}
            >
              Patient Name
            </th>
            <th
              style={{
                whiteSpace: "nowrap",
                padding: "8px 12px",
                fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
              }}
            >
              HMO Provider
            </th>
            <th
              style={{
                whiteSpace: "nowrap",
                padding: "8px 12px",
                fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
              }}
            >
              Membership Valid Until
            </th>
            <th
              style={{
                whiteSpace: "nowrap",
                padding: "8px 12px",
                fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
              }}
            >
              Status
            </th>
          </tr>
        </thead>

        <tbody className="white-bg view-det-pane">
          {data && data.length > 0 ? (
            data.map((row, index) => (
              <tr key={index}>
                <td
                  style={{
                    padding: "8px 12px",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                  }}
                >
                  {index + 1}
                </td>
                <td
                  style={{
                    padding: "8px 12px",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                    whiteSpace: "nowrap",
                  }}
                >
                  {row.patientFullName || "N/A"}
                </td>
                <td
                  style={{
                    padding: "8px 12px",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                    whiteSpace: "nowrap",
                  }}
                >
                  {hmoProviders[row.hmoProviderId] || "Unknown Provider"}
                </td>
                <td
                  style={{
                    padding: "8px 12px",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                    whiteSpace: "nowrap",
                  }}
                >
                  {formatDate(row.membershipValidity)}
                </td>
                <td
                  className={getStatusClass(row.membershipValidity)}
                  style={{
                    padding: "8px 12px",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                  }}
                >
                  {getStatusText(row.membershipValidity)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="5"
                style={{
                  textAlign: "center",
                  padding: "20px",
                  fontSize: "clamp(0.8rem, 2.5vw, 0.95rem)",
                }}
              >
                No HMO patients data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default HMOPatientsTable;
